// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/modelo-cars/list',
    name: 'modelo-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/Modelo.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_model_cars',
    },
  },
]

export default formTable
